// TODO these types should probably be moved:

// a product without a price is has no active offers for the best match returned by agolia
// we don't return a best match from our backend, so check if any variant is active
const isActive = product => {
  var _product$variant;
  return Boolean((_product$variant = product.variant) === null || _product$variant === void 0 ? void 0 : _product$variant.price) || product.otherVariants.some(v => v.price);
};
const ascSort = (a, b) => a - b;
const DISCOUNT_PERCENTAGE_ROUNDING_THRESHOLD = 0.9;
const DISCOUNT_PERCENTAGE_ROUNDING_OFFSET = -DISCOUNT_PERCENTAGE_ROUNDING_THRESHOLD + 0.5; // eslint-disable-line no-magic-numbers

const iVariantSelectors = {
  getOriginalPrice: variant => {
    var _variant$price;
    return variant === null || variant === void 0 || (_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : _variant$price.originalPrice;
  },
  getDiscountedPrice: variant => {
    var _variant$price2;
    return variant === null || variant === void 0 || (_variant$price2 = variant.price) === null || _variant$price2 === void 0 ? void 0 : _variant$price2.discountedPrice;
  },
  getEffectivePrice: variant => {
    var _variant$price3;
    return variant === null || variant === void 0 || (_variant$price3 = variant.price) === null || _variant$price3 === void 0 ? void 0 : _variant$price3.effectivePrice;
  }
};
const ascendingPrices = (variants, selector) => variants.flatMap(variant => {
  var _selector;
  return (_selector = selector(variant)) !== null && _selector !== void 0 ? _selector : [];
}).sort(ascSort);
const minMax = sorted => ({
  min: sorted[0],
  max: sorted[sorted.length - 1]
});
function variantsPriceRange(variants, _ref) {
  let {
    getOriginalPrice
  } = _ref;
  const prices = ascendingPrices(variants, getOriginalPrice);
  return prices.length === 0 ? undefined : minMax(prices);
}
function variantsDiscountedPriceRange(variants, _ref2) {
  let {
    getOriginalPrice,
    getEffectivePrice
  } = _ref2;
  const originalMinMax = minMax(ascendingPrices(variants, getOriginalPrice));
  const effectiveMinMax = minMax(ascendingPrices(variants, getEffectivePrice));
  const minsEqual = originalMinMax.min === effectiveMinMax.min;
  const maxsEqual = originalMinMax.max === effectiveMinMax.max;
  return minsEqual && maxsEqual ? undefined : effectiveMinMax;
}
function variantsDiscountPercentageRange(variants) {
  const discounts = variants.flatMap(v => {
    if (!v.price) {
      return [];
    }
    const originalPriceInCents = v.price.originalPrice * 100;
    const effectivePriceInCents = v.price.effectivePrice * 100;
    const percentage = (originalPriceInCents - effectivePriceInCents) / originalPriceInCents * 100;
    return Math.round(percentage + DISCOUNT_PERCENTAGE_ROUNDING_OFFSET);
  }).sort(ascSort);
  const {
    min,
    max
  } = minMax(discounts);
  return max === 0 ? undefined : {
    min,
    max
  };
}
function calculateProductRange(product, calculateVariantsRange) {
  if (!isActive(product)) {
    return undefined;
  }
  const variants = product.variant ? [product.variant, ...product.otherVariants] : product.otherVariants;
  return calculateVariantsRange(variants, iVariantSelectors);
}
export function priceRange(product) {
  return calculateProductRange(product, variantsPriceRange);
}
export function discountedPriceRange(product) {
  return calculateProductRange(product, variantsDiscountedPriceRange);
}
export function discountPercentageRange(product) {
  return calculateProductRange(product, variantsDiscountPercentageRange);
}